
import { defineComponent } from 'vue'
import CardTopRightButton from '@/components/CardTopRightButton.vue'

export default defineComponent({
  components: { CardTopRightButton },
  computed: {
    shopURL() {
      return process.env.VUE_APP_PLATFORM_SHOP_URL
    }
  }
})
